import { useLazyQuery } from '@apollo/client/react';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { GetUberQuoteDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { changeDeliveryMethodState } from '~/state/partials/change_delivery_method_modal/atoms';
import { requestUberDeliveryModalState } from '~/state/reception/atoms';

export const useFetchUberQuote = () => {
  const [state, setState] = useAtom(requestUberDeliveryModalState);
  const setChangeDeliveryMethodModal = useSetAtom(changeDeliveryMethodState);
  const [getQuote, { loading, error, data }] = useLazyQuery(GetUberQuoteDocument, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!data) return;

    const appointment = getNode(data, 'Appointment') || null;
    const uberQuote = appointment?.uberQuote;

    if (uberQuote?.quoteId) {
      setState((_state) => ({ ..._state, quoteId: uberQuote.quoteId as string }));
    }

    if (appointment && uberQuote?.errorCode && !uberQuote.quoteId) {
      if (uberQuote.errorCode === 'address_undeliverable') {
        setState((_state) => ({ ..._state, isOpen: false }));
        setChangeDeliveryMethodModal({
          isOpen: true,
          appointmentId: appointment.id,
        });
      } else {
        setState((_state) => ({
          ..._state,
          error: uberQuote.errorCode != null ? String(uberQuote.errorCode) : null,
        }));
      }
    }
  }, [data, setChangeDeliveryMethodModal, setState]);

  useEffect(() => {
    if (!error) return;
    setState((_state) => ({
      ..._state,
      graphqlError: error.message,
    }));
  }, [error, setState]);

  useEffect(() => {
    if (state.appointmentId) {
      getQuote({ variables: { id: state.appointmentId } });
    }
  }, [state.appointmentId, getQuote]);

  return { loading, error };
};
